import { useState } from "react";
import { DashboardUtils } from "../../../dashboard_utils";
import { trpc } from "../../../utils/trpc";
import { useQueryParams } from "../hooks/use_query_params";
import { InfoTooltip } from "../tooltips/info_tooltip";
import { DiscordEntitlement } from "./entitlements/discord_entitlement";
import { PatreonEntitlement } from "./entitlements/patreon_entitlement";
import { StripeEntitlement } from "./entitlements/stripe_entitlement";
import { PremiumServerListingsModal } from "./premium_server_listings_modal";
import { UseQueryResult } from "@tanstack/react-query";

export function PremiumActivePurchaseListings({
	premium_details_query,
}: {
	premium_details_query: UseQueryResult<any, unknown>;
}) {
	const query_params = useQueryParams<{ success?: boolean }>();
	const [premium_modal_opened, setPremiumModalOpened] = useState(
		query_params.success
	);

	if (!premium_details_query.isSuccess) {
		return <></>;
	}

	return (
		<>
			{premium_details_query.data.discord_entitlements.length > 0 && (
				<div className="flex flex-col gap-2">
					<div className="flex items-center gap-2">
						<div className="flex gap-2 text-lg font-bold">
							<div>Discord Purchases</div>
							<div className="flex items-center">
								<InfoTooltip
									info={
										"List of sesh premium purchases bought through Discord. Each individual subscription is tied to the server it is purchased for, whereas one-time purchases can be freely transferred between servers. If you wish to modify these subscriptions, you must do so through Discord."
									}
								/>
							</div>
						</div>
					</div>
					<div className="flex w-full flex-col gap-2">
						{premium_details_query.data.discord_entitlements
							.length > 0 &&
							premium_details_query.data.discord_entitlements.map(
								(val) => (
									<DiscordEntitlement {...val} key={val.id} />
								)
							)}
					</div>
				</div>
			)}
			{premium_details_query.data.max_activated_servers > 0 && (
				<div className="flex flex-col gap-2">
					<div className="flex">
						<div className="flex gap-2 text-lg font-bold">
							<div>Stripe Purchases</div>
							<div className="flex items-center">
								<InfoTooltip
									info={
										"List of sesh premium subscriptions bought through Stripe or Patreon. These subscriptions can be transferred to other servers freely. If you subscribe to more than one tier, your premium server activation count will include all of your purchases and be cumulative."
									}
								/>
							</div>
						</div>
						<div className="ml-auto">
							Activated Servers:{" "}
							{
								premium_details_query.data
									.transferrable_activated_servers_count
							}
							/{premium_details_query.data.max_activated_servers}{" "}
							<span
								className="manual-link"
								onClick={() => setPremiumModalOpened(true)}
							>
								Manage
							</span>
						</div>
					</div>
					<div className="flex w-full flex-col gap-2">
						{premium_details_query.data.stripe_entitlements.length >
							0 &&
							premium_details_query.data.stripe_entitlements.map(
								(val) => (
									<StripeEntitlement {...val} key={val.id} />
								)
							)}
						{premium_details_query.data.patreon_activations > 0 &&
							premium_details_query.data
								.is_patreon_purely_from_override && (
								<PatreonEntitlement
									{...premium_details_query.data}
								/>
							)}
					</div>
				</div>
			)}
			{premium_modal_opened && (
				<PremiumServerListingsModal
					premium_details={premium_details_query.data}
					onClose={() => setPremiumModalOpened(false)}
				/>
			)}
		</>
	);
}
